<template>
  <b-modal
    id="selectOption"
    size="md"
    ok-only
    ok-title="Chiudi"
    ok-variant="lisaweb"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
  >
    <template #modal-header="{cancel}">
      <div slot="modal-title" class="modal-title">
        <!-- <b-icon icon="cash"></b-icon> -->
        <span>{{ title }}</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="cancel(), close()"
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>

    <template #modal-footer="{ cancel }">
      <b-form-group>
        <div class="d-flex">
          <b-button @click="cancel()" class="btn--transparent mr-2" size="sm" variant="outline-secondary"
          >Annulla
          </b-button
          >
          <b-button
            :disabled="option == null"
            @click="
            $emit('select', option, note);
            cancel();
          "
            size="sm"
            variant="lisaweb"
          >Continua
          </b-button
          >
        </div>
      </b-form-group>
    </template>
    <div class="mt-3" style="display: flex; flex-direction: column; height: 300px;">
      <b-row>
        <div class="col-md-12 mb-3">
          Per procedere è necessario selezionare un'opzione
        </div>
      </b-row>
      <b-row>
        <div class="col-md-12">
          <base-select
            v-model="option"
            name="options"
            :label="title"
            :options="opts"
            @select="onSelectOption"
          />
        </div>
      </b-row>
      <b-row v-if="showNote">
        <div class="col-md-12 mt-2">
          <b-form-group label="Descrizione">
            <b-form-textarea
              v-model="note"
              rows="3"
              placeholder="Inserisci una nota..."
            />
          </b-form-group>
        </div>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import BaseSelect from "@/components/form/BaseSelect";
import BaseIcon from "@/components/BaseIcon";

export default {
  data() {
    return {
      option: null,
      note: null,
    };
  },
  components: {
    BaseSelect,
    BaseIcon,
  },
  props: {
    opts: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "Opzioni",
    },
    showNote: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  beforeMount() {
  },
  methods: {
    onSelectOption(selected) {
      this.option = selected;
    },
    onReset() {
      this.option = null;
      this.note = null;
    },
  },
};
</script>
<style lang="scss" scoped></style>
